import { Checkbox, type CheckboxProps } from "react-aria-components";

import { cn } from "@/shared/lib/cn";
import "./merry-checkbox.css";

export interface MerryCheckboxProps
  extends Omit<CheckboxProps, "children" | "className" | "aria-label"> {
  "aria-label": string;
  className?: string;
}

/** Compact circular checkbox, drawn without image resources or SVG filters. */
export function MerryCheckbox({ className, ...props }: MerryCheckboxProps) {
  return (
    <Checkbox {...props} className={cn("merry-checkbox", className)}>
      {({ isSelected, isIndeterminate }) => (
        <MerryCheckboxVisual isSelected={isSelected} isIndeterminate={isIndeterminate} />
      )}
    </Checkbox>
  );
}

/** Visual state only; the parent control owns interaction and accessibility. */
export function MerryCheckboxVisual({
  isSelected,
  isIndeterminate = false,
  className,
}: {
  isSelected: boolean;
  isIndeterminate?: boolean;
  className?: string;
}) {
  return (
        <svg className={className} aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none">
          {isIndeterminate ? (
            <>
              <circle cx="7.5" cy="7.5" r="7.5" fill="#0061FE" />
              <path d="M4 7.5h7" stroke="white" strokeWidth="1.5" />
            </>
          ) : isSelected ? (
            <path d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM11.5928 5.59283L6.75 10.4356L3.59467 7.28032L4.65533 6.21968L6.75 8.31435L10.5322 4.53217L11.5928 5.59283Z" fill="#0061FE" />
          ) : (
            <circle cx="7.5" cy="7.5" r="6.75" stroke="#19262B" strokeOpacity="0.3" strokeWidth="1.5" />
          )}
        </svg>
  );
}
